module.exports = __webpack_public_path__ + "static/Img_pledge_graph_03@2x-eb73cbebcfcf7070111f9f3ee3550b86.png";